import { Box, Button, List } from '@iheartjane/reefer';

import { renderFeelingIcon } from '@jane/bloom/components/iconMaps/filterIconMap';
import {
  useProductSearchFilters,
  useSearchParamFilter,
} from '@jane/bloom/hooks/filters';
import { FilterCategoryLabel } from '@jane/bloom/hooks/filters/useProductSearchFilters';

import { FilterActions } from './filterActions';

import styles from './feelings.module.css';

interface FilterFeelingsButtonListProps {
  availableProductsCount?: number;
  /** Injected by FilterButtonWrapper */
  closePopover?: () => void;
}

const filterKey = 'feelings';

export const FilterFeelingsButtonList = ({
  availableProductsCount,
  closePopover,
}: FilterFeelingsButtonListProps) => {
  const { getProductSearchFilterOptions } = useProductSearchFilters();
  const { clearFilter, getFilterOptionValue, getFilterStatus, setFilter } =
    useSearchParamFilter(filterKey);
  const filterOptions = getProductSearchFilterOptions(filterKey);

  return (
    <Box px={16} pt={16}>
      <List
        className={styles['buttons']}
        label={FilterCategoryLabel[filterKey]}
        mb={16}
      >
        {filterOptions.map((item) => {
          return (
            <List.Item key={`feelings/${item.value}`} alignment="left">
              <Button
                alignment="left"
                className={styles['button']}
                disabled={item.count === 0}
                full
                startIcon={renderFeelingIcon(item.value)}
                label={`${item.value} (${item.count})`}
                variant={
                  getFilterStatus(item.value) === 'selected'
                    ? 'tertiary-selected'
                    : 'tertiary'
                }
                onClick={() =>
                  setFilter(item.value, !getFilterOptionValue(item.value))
                }
              />
            </List.Item>
          );
        })}
      </List>
      <FilterActions
        availableProductsCount={availableProductsCount}
        handleClearAll={clearFilter}
        handleClose={closePopover}
        sticky
      />
    </Box>
  );
};
